import React from 'react';
import { Helmet } from 'react-helmet';
import PageBlocks from '../components/PageBlocks';

import DefaultLayout from '../layouts';
import useHome from '../utils/useHome';

import Button from '../components/Button';
const VariantHero202402 = () => {
  return (
    <div>
      <div className="w-full p-12 pt-32 bg-white flex flex-col lg:flex-row items-center gap-12 justify-center max-w-[1366px] mx-auto">
        <div className="order-1 lg:order-none">
          <video
            onClick={(e) => {
              if (!e.currentTarget.muted) {
                return;
              }
              e.currentTarget.requestFullscreen();
              e.currentTarget.muted = false;
              e.currentTarget.currentTime = 0;
              e.currentTarget.controls = true;

              e.currentTarget.play();
            }}
            autoPlay
            loop
            muted
            disableRemotePlayback={'true'}
            poster="/images/hp-video-poster.jpg"
            playsInline
            style={{ aspectRatio: '16 / 9', cursor: 'pointer' }}
            className="w-full max-w-full lg:w-[800px] hover:shadow-2xl transition lg:max-w-[100%]  xl:max-w-[45vw] bg-white lozad rounded-3xl"
          >
            <source data-src="https://d3gw2uv1ch7vdq.cloudfront.net/img/what-s-paperform_.mp4" />
          </video>
        </div>
        <div>
          <h1 className="text-xs text-olive mb-3">
            Easiest online form builder & form creator
          </h1>
          <h2 className="text-4xl font-semibold text-midnight">
            Create powerful forms, fast.
          </h2>
          <p className="text-sm text-midnight opacity-70">
            Paperform takes the headache out of creating and maintaining
            automated forms, eSignatures, surveys, bookings, payments and more,
            so you can get back to life.
          </p>

          <Button solid gold href="/register">
            Get Started - it's free
          </Button>
          <small className="block text-[11px] mt-2 text-midnight/50">
            Full access free trial for 7 days, no credit card needed.
          </small>
        </div>
      </div>
      <div className="max-w-[760px] text-center mx-auto my-3 px-3">
        <h3 className="text-xs text-midnight/50 mb-0 leading-[1.7]">
          Loved by 10K+ business owners and creators. Trusted by millions of
          respondents.
          <br /> Average rating of{' '}
          <span className="text-midnight font-semibold">
            4.8 out of 5 from 298 reviews
          </span>{' '}
          across Capterra, Trustpilot, G2 and Product Hunt
        </h3>
        <div className="text-center mx-auto grid grid-cols-3 w-full max-w-[700px] gap-6">
          <img
            className="w-full"
            src="/images/capterra-stars.jpg"
            alt="Capterra - 4.8 out of 5"
          />
          <img
            className="w-full"
            src="/images/trustpilot-stars.jpg"
            alt="Trustpilot - 4.7 out of 5"
          />
          <img
            className="w-full"
            src="/images/product-hunt-stars.jpg"
            alt="Product Hunt - 5 out of 5"
          />
        </div>
      </div>
      <div style={{ marginBottom: -130 }} />
    </div>
  );
};

export default function RebrandHomePage(props) {
  let { meta, content } = useHome();

  if (props.variant) {
    content = [...content.slice(1)];
    const statBlock = content[0];

    if (statBlock && statBlock.type === 'statBlock') {
      statBlock.statBlock.textColor = 'white';
      statBlock.statBlock.bgColor = 'var(--midnight)';
    }
  }

  return (
    <div className="bg-white w-full h-full">
      <DefaultLayout
        location={props.location}
        isTry={props.isTry}
        noFade
        fixedNav
      >
        <Helmet titleTemplate={false}>
          <title>
            {meta?.meta_title ||
              'Paperform: Online Form Builder And Form Creator'}
          </title>
          <meta
            name="description"
            content={
              meta?.meta_description ||
              'Paperform is a flexible online form builder that combines thoughtful design with serious digital smarts.'
            }
          />
          <meta
            property="og:title"
            content={
              meta?.og_title || 'Paperform: Where Imagination Takes Form'
            }
          />
          <meta
            property="og:description"
            content={
              meta?.og_description ||
              'Build beautiful, smart solutions that simplify your work and life.'
            }
          />
          <meta
            name="ahrefs-site-verification"
            content="7d9b940f7eafcfe2db327812738cbb7daad95091a696eec6f3fa5bdc4e059e90"
          />
          <script key="ld" type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'SoftwareApplication',
              name: 'Paperform',
              applicationCategory: 'WebApplication',
              aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: '4.8',
                ratingCount: '298',
              },
            })}
          </script>
        </Helmet>
        {props.variant ? <VariantHero202402 /> : null}

        {!props.loading && content?.length > 0 ? (
          content.map((block, i) => (
            <PageBlocks
              key={i}
              isFirst={i === 0}
              type={block.type}
              block={block}
            />
          ))
        ) : (
          <div className="min-h-screen"></div>
        )}
      </DefaultLayout>
    </div>
  );
}
